// Resumen del crédito para la firma: los pagos, la tasa y el total. Puro.
import type { CreditSummary } from './types';

export interface CreditTermsSummary {
    weeks: number;
    /** Pago semanal fijo, con IVA. */
    weeklyCents: number;
    /** La última cuota cuando el redondeo de centavos la mueve; `null` si es igual a las demás. */
    lastCents: number | null;
    financedCents: number;
    tnaPct: number;
    /** Suma de todas las cuotas. */
    totalCents: number;
}

/** La última cuota absorbe el residuo del redondeo: total − (plazo − 1) × pago semanal. */
export function creditTermsSummaryOf(
    credit: Pick<
        CreditSummary,
        | 'termWeeks'
        | 'weeklyPaymentWithIvaCents'
        | 'financedCapitalCents'
        | 'tnaAnnual'
        | 'totalToPayCents'
    >,
): CreditTermsSummary {
    const weekly = credit.weeklyPaymentWithIvaCents;
    const last = credit.totalToPayCents - (credit.termWeeks - 1) * weekly;
    return {
        weeks: credit.termWeeks,
        weeklyCents: weekly,
        lastCents: credit.termWeeks > 1 && last !== weekly ? last : null,
        financedCents: credit.financedCapitalCents,
        tnaPct: Math.round(credit.tnaAnnual * 100),
        totalCents: credit.totalToPayCents,
    };
}
